import { render, staticRenderFns } from "./TentangPenulis.vue?vue&type=template&id=48968918&"
import script from "./TentangPenulis.vue?vue&type=script&lang=js&"
export * from "./TentangPenulis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports